import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Shield, Phone, Mail } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { recruitmentfraudeData } from '../data/geoData';

const RecruitmentfraudePage = () => (
  <main className="pt-28 min-h-screen">
    <SEO title="Waarschuwing Recruitmentfraude - Staffing Force" description="Staffing Force waarschuwt voor recruitmentfraude. Lees hoe u frauduleuze communicatie herkent en wat u kunt doen." keywords="recruitmentfraude, waarschuwing, fraude, staffing force" />
    <PageHero label="Belangrijk" title={recruitmentfraudeData.title} description={recruitmentfraudeData.intro} image="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=1920&q=85&auto=format&fit=crop" />
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <FadeIn>
          <div className="bg-red-50 border border-red-200 rounded-xl p-8 mb-10">
            <div className="flex items-start gap-4">
              <AlertTriangle size={28} className="text-red-500 flex-shrink-0 mt-1" />
              <div>
                <h2 className="text-xl font-bold text-red-800 mb-4">Let op: herken fraude</h2>
                <ul className="space-y-3">{recruitmentfraudeData.warnings.map((w,i) => <li key={i} className="flex items-start gap-2 text-red-700 text-sm"><Shield size={14} className="mt-0.5 flex-shrink-0" />{w}</li>)}</ul>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Vermoedt u fraude?</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">Heeft u een verdacht bericht ontvangen namens Staffing Force? Neem dan direct contact met ons op zodat wij actie kunnen ondernemen.</p>
            <div className="space-y-3">
              <div className="flex items-center gap-3"><Phone size={18} className="text-[#00897B]" /><span className="text-gray-700 text-sm">(020) 58 11 000</span></div>
              <div className="flex items-center gap-3"><Mail size={18} className="text-[#00897B]" /><a href="mailto:info@staffingforce.nl" className="text-gray-700 text-sm hover:text-[#00897B] transition-colors">info@staffingforce.nl</a></div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  </main>
);

export default RecruitmentfraudePage;
